// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"3c343dda","488":"d3ade87a","885":"dfb0110c"}[chunkId] + ".chunk.js";
};